import React from 'react';
import { AsyncWelcomeModal } from '@atlassian/jira-software-onboarding-modals/src/ui/welcome-modal/async.tsx';
import { useShouldShowWelcomeModal } from '@atlassian/jira-software-onboarding-modals/src/ui/welcome-modal/utils.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useResource } from '@atlassian/react-resource-router';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const ConditionalWelcomeModalForSoftware = () => {
	const shouldShowModal = useShouldShowWelcomeModal('list');
	const { data } = useResource(projectContextResource);
	const isSoftwareProject = data?.projectType === 'software';
	return shouldShowModal && isSoftwareProject ? <AsyncWelcomeModal source="list" /> : null;
};

export const WelcomeModal = () => {
	if (!fg('jira_list_nin_merge')) {
		return null;
	}
	return (
		<JSErrorBoundary
			id="welcome-modal-list-view"
			packageName="jiraBusinessList"
			teamName="jlove-makkuro"
		>
			<ConditionalWelcomeModalForSoftware />
		</JSErrorBoundary>
	);
};
